<script>
import lucideIcons from './lucideIcons'
import { toPascalCase } from './iconMap'

function renderNodes(h, nodes) {
  if (!nodes || !nodes.length) return []
  return nodes.map((node) => {
    const tag = node[0]
    const attrs = node[1] || {}
    const children = node[2]
    return h(tag, { attrs }, children ? renderNodes(h, children) : undefined)
  })
}

export default {
  name: 'FuseIcon',
  functional: true,
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 20
    },
    strokeWidth: {
      type: [Number, String],
      default: 2
    }
  },
  render(h, ctx) {
    const icons = lucideIcons
    const pascal = toPascalCase(ctx.props.name)
    const iconNode = icons[pascal]
    const size = ctx.props.size
    if (!iconNode) {
      return h('span', {
        class: 'fuse-icon fuse-icon--missing',
        style: { width: size + 'px', height: size + 'px', display: 'inline-block' }
      })
    }
    return h(
      'svg',
      {
        class: ['fuse-icon', ctx.data.staticClass, ctx.data.class],
        style: ctx.data.style,
        attrs: Object.assign({}, ctx.data.attrs, {
          xmlns: 'http://www.w3.org/2000/svg',
          width: size,
          height: size,
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: 'currentColor',
          'stroke-width': ctx.props.strokeWidth,
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'aria-hidden': 'true'
        })
      },
      renderNodes(h, iconNode)
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/FuseIcon.vue